import { useImperativeHandle } from 'react';

import { useCascadeRef, useElementIsEllipsis } from '../../utils';
import { Tooltip } from '../Tooltip';

import type { ComponentProps, JSX, JSXElementConstructor } from 'react';

export interface BreadcrumbsItemProps extends ComponentProps<'span'> {
  slotProps?: {
    root?: Record<string, any>;
  };
  slots?: {
    root?: keyof JSX.IntrinsicElements | JSXElementConstructor<any>;
  };
}

export default function BreadcrumbsItem(props: BreadcrumbsItemProps) {
  const { ref, children, slots, slotProps, ...others } = props;
  const { root: RootSlotComponent = 'span' } = slots ?? {};
  const { root: rootSlotProps } = slotProps ?? {};

  const rootRef = useCascadeRef(null, ref);
  const { ref: ellipsisHandleRef, isEllipsis } = useElementIsEllipsis();
  useImperativeHandle<HTMLSpanElement | null, HTMLSpanElement | null>(
    ellipsisHandleRef,
    () => rootRef.current,
  );

  return (
    <Tooltip message={(isEllipsis && rootRef.current?.innerText) || ''}>
      <RootSlotComponent ref={rootRef} {...others} {...rootSlotProps}>
        {children}
      </RootSlotComponent>
    </Tooltip>
  );
}
